import 'events-polyfill';

// Create bus element or read from existing window variable (to prevent duplications across chunk files)
const globalBus = window.MVPS_EventBus || (window.MVPS_EventBus = document.createElement('div'));

export default class EventBus {

	constructor () {
		this.bus = document.createElement('div');
	}

	/**
	 * Global Event Bus
	 */
	static globalBus = globalBus;

	static addEventListener (event, callback) {

		globalBus.addEventListener(event, callback);

	}

	static removeEventListener (event, callback) {

		globalBus.removeEventListener(event, callback);

	}

	static dispatchEvent (event, detail = {}) {

		globalBus.dispatchEvent(new CustomEvent(event, {detail}));

	}

	/**
	 * Instanced Event Bus
	 */
	addEventListener (event, callback) {

		this.bus.addEventListener(event, callback);

	}

	removeEventListener (event, callback) {

		this.bus.removeEventListener(event, callback);

	}

	dispatchEvent (event, detail = {}) {

		this.bus.dispatchEvent(new CustomEvent(event, {detail}));

	}

}
